// extracted by mini-css-extract-plugin
export default {"ActivityIdCell":"ActivityIdCell_ActivityIdCell__9KPCb"};